import React from 'react'
import { Navigate } from 'react-router-dom';

const PageNotFound = () => {
    return <Navigate replace to='/' />
}

export default PageNotFound;
